import _ from 'lodash'
import {
  cachedConnect as connect,
} from './helpersHOC'
import Loading from '../components/Loading'
export default connect(
  (state, ownProps, {cachedState}) => {
    let isLoading = state.api.async.async === 'BUSY'
    let hasError = _.isObject(state.api.async.async)
    if (cachedState.isLoading !== isLoading ||
        cachedState.hasError !== hasError)
      cachedState = {isLoading: isLoading, hasError: hasError}
    return cachedState
  })(Loading)



// WEBPACK FOOTER //
// ./src/containers/Loading.js